export default "__VITE_ASSET__B0shkbK7__"